module.exports = __webpack_public_path__ + "0003e012fdad3671eb6e30aefa376510.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/confetti.png
// module id = 2742
// module chunks = 0